import { z } from 'zod'

export const assetDBSearchSchema = z.object({
  // Individual filter parameters
  asset: z.string().optional(),
  lastInspection: z.string().optional(),
  lastUpdated: z.string().optional(),
  components: z.array(z.string()).optional(),
  area: z.string().optional(),
  areaDescription: z.string().optional(),
  erpId: z.string().optional(),
  criticality: z.string().optional(),
  search: z.string().optional(),
})

export type AssetDBSearchParams = z.infer<typeof assetDBSearchSchema>
